import { NormalizeTypeRule } from '@doltech/ui/lib/figma/BlogEditor/plugins/withForceNormalizeTypes';
import { MediaType } from '@doltech/ui/lib/figma/DolEditor/elements/media-constant';
import { createMediaNode } from '@doltech/ui/lib/figma/DolEditor/elements/table-blog/transforms/addTable';
import { NewsContentTypeEnum } from '@doltech/utils/lib/constants';
import { getEmptyParagraphNode } from '@doltech/utils/lib/editor';
import { nanoid } from 'nanoid';

const getH1Node = (text = '') => {
  return {
    type: 'h1',
    id: nanoid(),
    placeholder: 'Please input title',
    children: [
      {
        text,
      },
    ],
  };
};

const replaceHeaderContentIfNotValid = ({ validType, content }) => {
  switch (validType) {
    case NewsContentTypeEnum.NEWS: {
      if (content?.[1]?.type !== MediaType.AUDIO) {
        content[1] = createMediaNode(MediaType.AUDIO, { noDeleteBtn: true });
      }
      break;
    }
    case NewsContentTypeEnum.VIDEO: {
      if (content?.[1]?.type !== MediaType.VIDEO) {
        content[1] = createMediaNode(MediaType.VIDEO, { noDeleteBtn: true });
      }
      break;
    }
    case NewsContentTypeEnum.KNOWLEDGE:
    default: {
      content = content.filter((node) => node?.type === 'h1');
    }
  }
  if (content?.[0]?.type !== 'h1') {
    content = [getH1Node()];
  }
  return content;
};

const forceTitleNode: NormalizeTypeRule = {
  path: [0],
  strictNode: {
    type: 'h1',
    placeholder: 'Please input title',
    getDefaultValue: getH1Node,
  },
};

export const getInitialHeader = (detailData) => {
  if (detailData?.header) {
    const content =
      typeof detailData.header.content === 'string'
        ? JSON.parse(detailData.header.content)
        : detailData.header.content;
    return {
      ...detailData.header,
      content: replaceHeaderContentIfNotValid({ validType: detailData.contentType, content }),
    };
  }

  switch (detailData?.contentType) {
    case NewsContentTypeEnum.NEWS: {
      return {
        id: nanoid(),
        content: [getH1Node(), createMediaNode(MediaType.AUDIO, { noDeleteBtn: true })],
      };
    }
    case NewsContentTypeEnum.VIDEO: {
      return {
        id: nanoid(),
        content: [getH1Node(), createMediaNode(MediaType.VIDEO, { noDeleteBtn: true })],
      };
    }
    case NewsContentTypeEnum.KNOWLEDGE:
    default:
      return {
        id: nanoid(),
        content: [getH1Node()],
      };
  }
};

export const getInitialBody = (detailData) => {
  if (detailData?.body) {
    return {
      ...detailData.body,
      content:
        typeof detailData.body.content === 'string'
          ? JSON.parse(detailData.body.content)
          : detailData.body.content,
    };
  }

  return {
    id: nanoid(),
    content: [getEmptyParagraphNode()],
  };
};

export const getDailyNewsHeaderNormalizeType = (detailData): NormalizeTypeRule[] => {
  switch (detailData?.contentType) {
    case NewsContentTypeEnum.NEWS: {
      return [
        forceTitleNode,
        {
          path: [1],
          strictNode: {
            type: MediaType.AUDIO,
            getDefaultValue: () => {
              return createMediaNode(MediaType.AUDIO, { noDeleteBtn: true });
            },
          },
        },
      ];
    }
    case NewsContentTypeEnum.VIDEO: {
      return [
        forceTitleNode,
        {
          path: [1],
          strictNode: {
            type: MediaType.VIDEO,
            getDefaultValue: () => {
              return createMediaNode(MediaType.VIDEO, { noDeleteBtn: true, aaa: 'aaa' });
            },
          },
        },
      ];
    }

    case NewsContentTypeEnum.KNOWLEDGE:
    default:
      return [forceTitleNode];
  }
};
